import {SxProps} from '@mui/material';
import {Color} from '$constants/style';

interface PaymentSummaryBoxStyles {
  container: SxProps & {width: string | number};
  contentBox: SxProps;
  headerText: SxProps;
  totalAmount: SxProps;
  itemText: SxProps;
  payableLabel: SxProps;
}

export const styles: PaymentSummaryBoxStyles = {
  container: {
    background: `linear-gradient(132.83deg, ${Color.PrimaryMain} 25.95%, ${Color.Primary2Dark} 107.21%)`,
    color: 'white',
    padding: '25px 30px',
    width: '100%  ',
    maxWidth: 464,
    height: '209px',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    position: 'relative',
  },
  contentBox: {
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    justifyContent: 'space-between',
  },
  headerText: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '20px',
    fontFamily: 'Inter',
    letterSpacing: '-0.75%',
  },
  totalAmount: {
    mt: 2,
    fontWeight: 600,
    fontSize: '32px',
    lineHeight: '38px',
  },
  itemText: {
    fontFamily: 'Inter',
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.63)',
  },
  payableLabel: {
    fontWeight: 300,
    fontSize: '14px',
    lineHeight: '18px',
  },
};
